import { Building2, Gamepad2, Gauge, ShieldCheck, ArrowUpRight, Check } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { SERVICES } from "@/data/content";

const ICONS = { Building2, Gamepad2, Gauge, ShieldCheck };

export const Services = () => {
  return (
    <section id="servicos" className="relative border-t border-[#1A1A20] bg-[#0A0A0C]">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
        <SectionHeading
          number="03"
          label="Serviços"
          title="O que eu construo"
          accent="para você."
        />

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2">
          {SERVICES.map((service, i) => {
            const Icon = ICONS[service.icon];
            return (
              <Reveal key={service.id} delay={(i % 2) * 0.12}>
                <div
                  data-testid={`service-card-${service.id}`}
                  className="card-glow group relative h-full overflow-hidden rounded-2xl border border-[#22222A] bg-[#101014] p-8 sm:p-10"
                >
                  <div
                    aria-hidden="true"
                    className="pointer-events-none absolute -right-20 -top-20 h-48 w-48 rounded-full opacity-0 blur-[80px] transition-opacity duration-500 group-hover:opacity-25"
                    style={{ background: "#E50914" }}
                  />
                  <div className="flex items-start justify-between">
                    <div className="flex h-14 w-14 items-center justify-center rounded-xl border border-[#E50914]/30 bg-[#E50914]/10">
                      <Icon className="h-6 w-6 text-[#E50914]" />
                    </div>
                    <span className="rounded-full border border-[#2A2A33] px-3 py-1 font-mono-code text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                      {service.badge}
                    </span>
                  </div>
                  <h3 className="mt-8 font-display text-xl font-bold text-zinc-100 sm:text-2xl">
                    {service.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-zinc-400 sm:text-base">
                    {service.description}
                  </p>
                  <ul className="mt-6 space-y-2.5">
                    {service.points.map((point) => (
                      <li key={point} className="flex items-center gap-2.5 text-sm text-zinc-300">
                        <Check className="h-4 w-4 shrink-0 text-[#E50914]" />
                        {point}
                      </li>
                    ))}
                  </ul>
                  <ArrowUpRight className="absolute bottom-8 right-8 h-5 w-5 text-zinc-700 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-[#E50914]" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
